/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubLimitResponseDto
 */
export interface SubLimitResponseDto {
    /**
     * 
     * @type {Date}
     * @memberof SubLimitResponseDto
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SubLimitResponseDto
     */
    updatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof SubLimitResponseDto
     */
    subLimitId: string;
    /**
     * 
     * @type {string}
     * @memberof SubLimitResponseDto
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof SubLimitResponseDto
     */
    peril: string;
    /**
     * 
     * @type {string}
     * @memberof SubLimitResponseDto
     */
    amount: string;
    /**
     * 
     * @type {string}
     * @memberof SubLimitResponseDto
     */
    submissionId: string;
}

/**
 * Check if a given object implements the SubLimitResponseDto interface.
 */
export function instanceOfSubLimitResponseDto(value: object): value is SubLimitResponseDto {
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    if (!('subLimitId' in value) || value['subLimitId'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('peril' in value) || value['peril'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('submissionId' in value) || value['submissionId'] === undefined) return false;
    return true;
}

export function SubLimitResponseDtoFromJSON(json: any): SubLimitResponseDto {
    return SubLimitResponseDtoFromJSONTyped(json, false);
}

export function SubLimitResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubLimitResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'createdAt': (new Date(json['createdAt'])),
        'updatedAt': (new Date(json['updatedAt'])),
        'subLimitId': json['subLimitId'],
        'country': json['country'],
        'peril': json['peril'],
        'amount': json['amount'],
        'submissionId': json['submissionId'],
    };
}

export function SubLimitResponseDtoToJSON(json: any): SubLimitResponseDto {
    return SubLimitResponseDtoToJSONTyped(json, false);
}

export function SubLimitResponseDtoToJSONTyped(value?: SubLimitResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'createdAt': ((value['createdAt']).toISOString()),
        'updatedAt': ((value['updatedAt']).toISOString()),
        'subLimitId': value['subLimitId'],
        'country': value['country'],
        'peril': value['peril'],
        'amount': value['amount'],
        'submissionId': value['submissionId'],
    };
}

